<template>
  <!-- 二代登录：直接渲染代理商专属 Dashboard（VAP 销售额对他们无意义）-->
  <AgentDashboard v-if="userType === 2" />
  <!-- 客户登录：直接渲染客户专属 Dashboard -->
  <CustomerDashboard v-else-if="userType === 4" />
  <!-- admin/sales：保持原 Sales Overview -->
  <div v-else class="vs-main">
    <div class="vs-page-header">
      <div style="display: flex; align-items: center; gap: 12px">
        <div class="vs-seg-control"><button class="vs-seg-btn active">Dashboard</button></div>
      </div>
      <div class="vs-header-actions">
        <select class="vs-form-select" v-model="selectedYear" @change="loadData" style="min-width: 80px">
          <option v-for="y in yearOptions" :key="y.value" :value="y.value">{{ y.label }}</option>
        </select>
        <span class="vs-time-badge">{{ currentTime }}</span>
      </div>
    </div>
    <div class="vs-kpi-grid vs-kpi-grid-4" style="margin-bottom: 20px">
      <div class="vs-kpi-card" v-for="kpi in kpiData" :key="kpi.label">
        <div class="vs-kpi-label">{{ kpi.label }}</div>
        <div class="vs-kpi-value">{{ kpi.value }}</div>
        <div :class="['vs-kpi-change', kpi.trend]">{{ kpi.change }}</div>
      </div>
    </div>
    <div :style="{display:'grid', gridTemplateColumns: isLimited ? '1fr 1fr' : '1fr 1fr 1fr', gap:0, marginBottom:'20px'}">
      <div class="vs-card" style="border-right: none" v-if="!isLimited">
        <div class="vs-card-head"><span class="vs-card-label">Annual Sales by Rep</span></div>
        <div class="vs-card-inner"><div class="vs-chart-container h280" ref="chartRepRef"></div></div>
      </div>
      <div class="vs-card" style="border-right: none">
        <div class="vs-card-head"><span class="vs-card-label">Quarterly Year-over-Year</span></div>
        <div class="vs-card-inner"><div class="vs-chart-container h280" ref="chartQoqRef"></div></div>
      </div>
      <div class="vs-card">
        <div class="vs-card-head"><span class="vs-card-label">Regional Distribution</span></div>
        <div class="vs-card-inner"><div class="vs-chart-container h280" ref="chartRegionRef"></div></div>
      </div>
    </div>
    <div :style="{display:'grid', gridTemplateColumns: isLimited ? '1fr' : '1fr 1fr', gap:0, marginBottom:'20px'}">
      <div class="vs-card" :style="{borderRight: isLimited ? '' : 'none'}">
        <div class="vs-card-head"><span class="vs-card-label">Monthly Sales Trend</span></div>
        <div class="vs-card-inner"><div class="vs-chart-container h280" ref="chartTrendRef"></div></div>
      </div>
      <div class="vs-card" v-if="!isLimited">
        <div class="vs-card-head"><span class="vs-card-label">Top 10 Partners (This Month)</span></div>
        <div class="vs-card-inner"><div class="vs-chart-container h280" ref="chartTop10Ref"></div></div>
      </div>
    </div>
    <div class="vs-card" style="margin-bottom: 20px">
      <div class="vs-card-head"><span class="vs-card-label">Monthly Revenue &amp; Growth Rate</span></div>
      <div class="vs-card-inner"><div class="vs-chart-container h280" ref="chartGrowthRef"></div></div>
    </div>
    <div class="vs-table-wrap">
      <div class="vs-table-header">
        <span class="vs-table-title">Cost and usage breakdown</span>
      </div>
      <div class="vs-table-toolbar" style="display:flex;justify-content:space-between;align-items:center;flex-wrap:wrap;gap:8px">
        <div class="vs-table-filters" style="flex:1;flex-wrap:wrap">
          <label class="vs-filter-label">Period:</label>
          <input type="month" class="vs-form-input" v-model="tblStartMonth" style="width:130px" />
          <span style="color:var(--aws-text-label);font-size:14px">to</span>
          <input type="month" class="vs-form-input" v-model="tblEndMonth" style="width:130px" />
          <label class="vs-filter-label" style="margin-left:8px">Filter:</label>
          <select class="vs-form-select vs-filter-select" v-model="filterType" @change="loadTableData" style="width:70px">
            <option value="" disabled hidden>Type</option>
            <option value="">All</option>
            <option value="CN">CN</option>
            <option value="GLB">GLB</option>
          </select>
          <select class="vs-form-select vs-filter-select" v-model="filterRegion" @change="loadTableData" style="width:70px">
            <option value="" disabled hidden>Region</option>
            <option value="">All</option>
            <option v-for="r in regionOptions" :key="r" :value="r">{{ r }}</option>
          </select>
          <select v-if="!isLimited" class="vs-form-select vs-filter-select" v-model="filterRep" @change="loadTableData" style="width:70px">
            <option value="" disabled hidden>Sales Rep</option>
            <option value="">All</option>
            <option v-for="r in repOptions" :key="r" :value="r">{{ r }}</option>
          </select>
          <select v-if="!isLimited" class="vs-form-select vs-filter-select" v-model="filterAgent" @change="loadTableData" style="width:70px">
            <option value="" disabled hidden>Agent</option>
            <option value="">All</option>
            <option v-for="a in agentOptions" :key="a.id" :value="a.id">{{ a.name }}</option>
          </select>
        </div>
        <div style="display:flex;gap:6px;flex-shrink:0">
          <button class="vs-btn vs-btn-primary" @click="loadTableData">Query</button>
          <button class="vs-btn vs-btn-outline" @click="downloadCSV">CSV</button>
        </div>
      </div>
      <table class="vs-tbl">
        <thead><tr><th>Agent ID</th><th>Agent Name</th><th>Region</th><th v-if="!isLimited">Sales Rep</th><th>Type</th><th class="r">Charge (USD)</th><th class="r">Cost (USD)</th></tr></thead>
        <tbody>
          <tr v-if="filteredTableRows.length === 0"><td :colspan="isLimited ? 6 : 7" style="text-align:center;color:var(--aws-text-muted);padding:40px">No data. Select a period and click Query.</td></tr>
          <tr v-for="row in filteredTableRows" :key="row.id + row.region + row.rep">
            <td>{{ row.id }}</td><td>{{ row.name }}</td>
            <td><span :class="['vs-tag', row.type === 'CN' ? 'vs-tag-orange' : 'vs-tag-blue']">{{ row.region }}</span></td>
            <td v-if="!isLimited">{{ row.rep }}</td>
            <td><span :class="['vs-tag', row.type === 'CN' ? 'vs-tag-orange' : 'vs-tag-green']">{{ row.type }}</span></td>
            <td class="r vs-text-bold">{{ row.charge }}</td>
            <td class="r vs-text-bold">{{ row.cost }}</td>
          </tr>
        </tbody>
      </table>
      <div class="vs-table-footer">
        <span class="vs-table-footer-info">Showing 1-{{ filteredTableRows.length }} of {{ filteredTableRows.length }} results</span>
        <div class="vs-page-btns"><button class="vs-pg-btn active">1</button></div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, nextTick } from 'vue'
import { useRouter } from 'vue-router'
import * as echarts from 'echarts'
import { ajaxGet } from '@/api/request'
import '@/assets/css/aws-console.scss'
import AgentDashboard from './agentDashboard.vue'
import CustomerDashboard from './customerDashboard.vue'

const router = useRouter()
const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}')
const userType = Number(userInfo.type) || 0
const isLimited = userType === 2 || userType === 4
const AWS_PALETTE = ['#6B9BD2','#2E5F99','#067F68','#D13212','#8C6BB1','#EC7211','#00A1C9','#879596','#DD6B7A','#3F8FD2','#1D8102','#F2C94C']
const now = new Date()
const currentTime = ref(`${now.getFullYear()}/${String(now.getMonth()+1).padStart(2,'0')}/${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`)
const selectedYear = ref('current')
const yearOptions = ref([{ label: 'Current', value: 'current' }])

async function loadYearOptions() {
  try {
    const res = await ajaxGet({ url: '/stat/analysis/available_years/' })
    const years = res?.data || []
    const cy = String(now.getFullYear())
    yearOptions.value = [{ label: 'Current', value: 'current' }]
    years.filter(y => String(y) !== cy).forEach(y => yearOptions.value.push({ label: String(y), value: String(y) }))
  } catch (e) {
    yearOptions.value = [{ label: 'Current', value: 'current' }, { label: String(now.getFullYear()-1), value: 'last' }]
  }
}

function fv(v) {
  if (Math.abs(v) >= 1e5) return '$' + (v/1e6).toFixed(2) + 'M'
  if (Math.abs(v) >= 1e3) return '$' + (v/1e3).toFixed(2) + 'K'
  return '$' + (v||0).toFixed(2)
}
function fa(v) { return fv(v).replace('$','') }
function ft(params) {
  let s = params[0]?.axisValue || ''
  params.forEach(p => {
    const v = p.value
    const f = (p.seriesName||'').includes('Growth') || (p.seriesName||'').includes('Rate') ? (v!=null ? v.toFixed(2)+'%' : '-') : fv(v)
    s += '<br/>' + p.marker + ' ' + p.seriesName + ': ' + f
  })
  return s
}

const kpiData = ref([
  { label: 'Annual sales (YTD)', value: '-', change: '', trend: 'neutral' },
  { label: 'Monthly sales (MTD)', value: '-', change: '', trend: 'neutral' },
  { label: 'Active agents (Year)', value: '0', change: 'no change', trend: 'neutral' },
  { label: 'Active agents (Month)', value: '0', change: 'no change', trend: 'neutral' },
])
const tableRows = ref([])
const filteredTableRows = ref([])
const filterRegion = ref('')
const filterRep = ref('')
const filterType = ref('')
const filterAgent = ref('')
const regionOptions = ref(['北区','南区','东区','西区'])
const repOptions = ref([])
const agentOptions = ref([])
const tblStartMonth = ref('')
const tblEndMonth = ref('')
const chartRepRef = ref(null)
const chartQoqRef = ref(null)
const chartRegionRef = ref(null)
const chartTrendRef = ref(null)
const chartTop10Ref = ref(null)
const chartGrowthRef = ref(null)
const charts = []

function ic(el, opt) { if (!el) return; const c = echarts.init(el); c.setOption(opt); charts.push(c) }
const TT = { backgroundColor: '#16191F', borderColor: '#16191F', textStyle: { color: '#fff' } }

function applyFilters() {
  filteredTableRows.value = tableRows.value
}

async function loadTableData() {
  const params = { year_mode: selectedYear.value }
  if (tblStartMonth.value && tblEndMonth.value) {
    params.start_month = tblStartMonth.value.replace('-','')
    params.end_month = tblEndMonth.value.replace('-','')
  }
  if (filterType.value) params.region_type = filterType.value
  if (filterRegion.value) params.sales_region = filterRegion.value
  if (filterRep.value) params.sales_name = filterRep.value
  if (filterAgent.value) params.agent_id = filterAgent.value
  try {
    const pR = await ajaxGet({url:'/stat/dashboard/partner_sales/',params})
    const pD = pR?.data || []
    const mx = Math.max(...pD.map(r=>r.sales_amount||0),1)
    tableRows.value = pD.map(r=>({
      id: r.agent_id||'',
      name: r.agent_name||'',
      region: r.sales_region||'-',
      rep: r.sales_name||'-',
      type: r.region_type||'GLB',
      charge: (r.total_charge||0).toFixed(4),
      cost: (r.sales_amount||0).toFixed(4)
    }))
    // Extract unique reps and agents for filter options (from full result set)
    repOptions.value = [...new Set(pD.map(r=>r.sales_name).filter(v=>v&&v!=='未分配'&&v!=='test'))].sort()
    const agents = [...new Map(pD.map(r=>[r.agent_id, {id:r.agent_id, name:r.agent_name}])).values()]
    if (agents.length > 0) agentOptions.value = agents.sort((a,b)=>(a.name||'').localeCompare(b.name||''))
    applyFilters()
  } catch(e) { console.error('loadTableData error:', e) }
}

function downloadCSV() {
  const rows = filteredTableRows.value
  if (!rows.length) return
  const header = isLimited
    ? 'Agent ID,Agent Name,Region,Type,Charge (USD),Cost (USD)\n'
    : 'Agent ID,Agent Name,Region,Sales Rep,Type,Charge (USD),Cost (USD)\n'
  const body = rows.map(r=> isLimited
    ? `${r.id},"${r.name}",${r.region},${r.type},${r.charge},${r.cost}`
    : `${r.id},"${r.name}",${r.region},${r.rep},${r.type},${r.charge},${r.cost}`).join('\n')
  const blob = new Blob(['\uFEFF'+header+body], {type:'text/csv;charset=utf-8'})
  const a = document.createElement('a'); a.href = URL.createObjectURL(blob); a.download = 'cost_breakdown.csv'; a.click()
}

async function loadData() {
  charts.forEach(c => c.dispose()); charts.length = 0
  // Sync table date range with year selector
  const yr = selectedYear.value === 'current' ? String(now.getFullYear()) : selectedYear.value
  tblStartMonth.value = `${yr}-01`
  tblEndMonth.value = selectedYear.value === 'current' ? `${yr}-${String(now.getMonth()+1).padStart(2,'0')}` : `${yr}-12`
  const params = { year_mode: selectedYear.value }
  try {
    const [tR,cR,aR,qR,mR,rR,pR,mtR] = await Promise.all([
      ajaxGet({url:'/stat/dashboard/total_sales/',params}),
      ajaxGet({url:'/stat/dashboard/monthly_sales_current/',params}),
      ajaxGet({url:'/stat/dashboard/agent_stats/',params}),
      ajaxGet({url:'/stat/dashboard/quarterly_compare/',params}),
      ajaxGet({url:'/stat/dashboard/monthly_sales/',params}),
      ajaxGet({url:'/stat/dashboard/region_sales/',params}),
      ajaxGet({url:'/stat/dashboard/partner_sales/',params}),
      ajaxGet({url:'/stat/dashboard/monthly_total_sales/',params}),
    ])
    // KPI
    kpiData.value[0].value = fv(tR?.total_sales||0)
    const md = cR?.data||[]
    kpiData.value[1].value = fv(md.reduce((s,r)=>s+(r.sales_amount||0),0))
    kpiData.value[2].value = String(aR?.year||0)
    kpiData.value[3].value = String(aR?.month||0)

    // C1: Annual Sales by Rep (aggregate from monthly_sales data)
    const mD=mR||[]
    const repTotals = {}
    mD.forEach(r => {
      const rep = r.sales || '未分配'
      repTotals[rep] = (repTotals[rep] || 0) + (r.sales_amount || 0)
    })
    const repNames = Object.keys(repTotals).sort((a,b) => repTotals[b] - repTotals[a])
    ic(chartRepRef.value, {
      grid:{left:60,right:20,top:10,bottom:30},
      xAxis:{type:'category',data:repNames,axisLine:{lineStyle:{color:'#EAEDED'}},axisLabel:{color:'#545B64'}},
      yAxis:{type:'value',axisLabel:{color:'#545B64',formatter:fa},splitLine:{lineStyle:{color:'#EAEDED'}}},
      series:[{type:'bar',data:repNames.map(n=>repTotals[n]),barWidth:'50%',itemStyle:{color:p=>AWS_PALETTE[p.dataIndex%AWS_PALETTE.length]}}],
      tooltip:{trigger:'axis',...TT,formatter:ft},
    })

    // C2: Quarterly YoY + Growth
    const qD=qR||[], ql=['Q1','Q2','Q3','Q4'], cy=String(now.getFullYear()), ly=String(now.getFullYear()-1)
    const qC=ql.map(q=>{const r=qD.find(d=>d.year===cy&&d.quarter===q);return r?r.sales_amount:0})
    const qL=ql.map(q=>{const r=qD.find(d=>d.year===ly&&d.quarter===q);return r?r.sales_amount:0})
    const qG=ql.map((_,i)=>qL[i]>0?((qC[i]-qL[i])/qL[i]*100):(qC[i]>0?100:0))
    ic(chartQoqRef.value, {
      grid:{left:60,right:50,top:30,bottom:50},
      legend:{bottom:0,textStyle:{color:'#545B64',fontSize:12}},
      xAxis:{type:'category',data:ql,axisLine:{lineStyle:{color:'#EAEDED'}},axisLabel:{color:'#545B64'}},
      yAxis:[{type:'value',axisLabel:{color:'#545B64',formatter:fa},splitLine:{lineStyle:{color:'#EAEDED'}}},{type:'value',position:'right',axisLabel:{color:'#545B64',formatter:v=>v.toFixed(0)+'%'},splitLine:{show:false}}],
      series:[
        {name:ly,type:'bar',data:qL,barWidth:'30%',itemStyle:{color:'#879596'}},
        {name:cy,type:'bar',data:qC,barWidth:'30%',itemStyle:{color:'#6B9BD2'}},
        {name:'Growth Rate',type:'line',yAxisIndex:1,data:qG,lineStyle:{color:'#EC7211',width:2},itemStyle:{color:'#EC7211'},symbol:'circle',symbolSize:6,label:{show:true,formatter:p=>p.value.toFixed(1)+'%',color:'#EC7211',fontSize:11}},
      ],
      tooltip:{trigger:'axis',...TT,formatter:ft},
    })

    // C3: Regional Distribution
    const rD=rR||[], rT=rD.reduce((s,r)=>s+(r.sales_amount||0),0)||1
    ic(chartRegionRef.value, {
      legend:{orient:'vertical',right:10,top:'center',textStyle:{color:'#545B64',fontSize:12}},
      series:[{type:'pie',radius:['55%','75%'],center:['35%','50%'],label:{show:false},
        data:rD.map((r,i)=>({value:r.sales_amount||0,name:(r.region||'?')+' '+((r.sales_amount||0)/rT*100).toFixed(1)+'%',itemStyle:{color:AWS_PALETTE[i%AWS_PALETTE.length]}}))}],
      tooltip:{trigger:'item',...TT,formatter:p=>p.name+'<br/>'+fv(p.value)},
    })

    // C4: Monthly Sales Trend
    const am=[...new Set(mD.map(r=>r.month))].sort(), sr=[...new Set(mD.map(r=>r.sales))]
    ic(chartTrendRef.value, {
      grid:{left:60,right:20,top:40,bottom:30},
      legend:{top:0,textStyle:{color:'#545B64',fontSize:12}},
      xAxis:{type:'category',data:am,axisLine:{lineStyle:{color:'#EAEDED'}},axisLabel:{color:'#545B64'}},
      yAxis:{type:'value',axisLabel:{color:'#545B64',formatter:fa},splitLine:{lineStyle:{color:'#EAEDED'}}},
      series:sr.map((rep,i)=>({name:rep,type:'line',data:am.map(m=>{const f=mD.find(r=>r.month===m&&r.sales===rep);return f?f.sales_amount:0}),lineStyle:{color:AWS_PALETTE[i%AWS_PALETTE.length],width:2},itemStyle:{color:AWS_PALETTE[i%AWS_PALETTE.length]},symbol:'circle',symbolSize:6,smooth:true})),
      tooltip:{trigger:'axis',...TT,formatter:ft},
    })

    // C5: Top 10 Partners
    const pD=pR?.data||[], t10=pD.slice(0,10)
    ic(chartTop10Ref.value, {
      grid:{left:140,right:30,top:10,bottom:20},
      xAxis:{type:'value',axisLabel:{color:'#545B64',formatter:fa},splitLine:{lineStyle:{color:'#EAEDED'}}},
      yAxis:{type:'category',data:t10.map(r=>r.agent_name||'').reverse(),axisLine:{lineStyle:{color:'#EAEDED'}},axisLabel:{color:'#545B64',fontSize:11}},
      series:[{type:'bar',data:t10.map(r=>r.sales_amount||0).reverse(),barWidth:'50%',itemStyle:{color:'#6B9BD2'}}],
      tooltip:{trigger:'axis',...TT,formatter:ft},
    })

    // C6: Monthly Revenue & Growth Rate
    const mtD=mtR||[], mtM=mtD.map(r=>'M'+(r.month||'')), mtV=mtD.map(r=>r.sales_amount||0)
    const mtG=mtV.map((v,i)=>i===0?0:(mtV[i-1]===0?0:((v-mtV[i-1])/mtV[i-1]*100)))
    ic(chartGrowthRef.value, {
      grid:{left:60,right:60,top:30,bottom:50},
      legend:{bottom:0,textStyle:{color:'#545B64',fontSize:12}},
      xAxis:{type:'category',data:mtM,axisLine:{lineStyle:{color:'#EAEDED'}},axisLabel:{color:'#545B64'}},
      yAxis:[{type:'value',position:'left',axisLabel:{color:'#545B64',formatter:fa},splitLine:{lineStyle:{color:'#EAEDED'}}},{type:'value',position:'right',axisLabel:{color:'#545B64',formatter:v=>v.toFixed(0)+'%'},splitLine:{show:false}}],
      series:[
        {name:'Monthly Sales',type:'bar',yAxisIndex:0,data:mtV,barWidth:'40%',itemStyle:{color:'#6B9BD2'}},
        {name:'Growth Rate',type:'line',yAxisIndex:1,data:mtG,lineStyle:{color:'#EC7211',width:2},itemStyle:{color:'#EC7211'},symbol:'circle',symbolSize:6,label:{show:true,formatter:p=>p.value!=null?p.value.toFixed(1)+'%':'',color:'#EC7211',fontSize:11}},
      ],
      tooltip:{trigger:'axis',...TT,formatter:ft},
    })

    // Table — load via dedicated function
    await loadTableData()
  } catch(e) { console.error('SalesOverview loadData error:',e) }
}

function handleResize() { charts.forEach(c=>c.resize()) }
onMounted(()=>{ nextTick(async()=>{
  // 二代/客户走子组件渲染（AgentDashboard/CustomerDashboard），本组件 admin 视图的图表/表格不挂载，跳过对应数据加载避免 refs 为 null 报错
  if (userType === 2 || userType === 4) return
  const n=new Date(); tblStartMonth.value=`${n.getFullYear()}-01`; tblEndMonth.value=`${n.getFullYear()}-${String(n.getMonth()+1).padStart(2,'0')}`
  await loadYearOptions(); await loadData(); window.addEventListener('resize',handleResize)
}) })
onBeforeUnmount(()=>{ window.removeEventListener('resize',handleResize); charts.forEach(c=>c.dispose()) })
</script>

<style lang="scss" scoped>
.vs-main { margin: -24px; padding: 20px 28px 40px; }
.vs-filter-label { font-size: 14px; color: var(--aws-text-secondary); font-weight: 400; white-space: nowrap; }
.vs-filter-select { color: var(--aws-text-primary); }
.vs-filter-select option[disabled] { color: var(--aws-text-muted); }
</style>
